


















































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import moment from 'moment';
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import PreviewImageSidebar from "../../components/PreviewImageSidebar.vue";
import { BModal, BCarousel } from 'bootstrap-vue';
import { Sheet, Examinee, TotalResult, Part1Result, FieldResult, SchoolSetting } from "../../modules/teacher/ResultRankDetail"


export interface Data {
  sheet_id: string
  student_no: string
  sheet: Sheet
  examinee: Examinee
  total_result: TotalResult
  part1_results: Part1Result[]
  field_results: FieldResult[]
  SheetTypeEnum: Readonly<{Normal: number; Cbt: number; Entrance: number}>
  sort_part1_asc: boolean
  sort_total_average_asc: boolean
  sort_correct_state_asc: boolean
  sort_field_asc: boolean
  windowHeight: number
  pdf_url: string
  errors: string[]
  isStudentSite: boolean
  isScanImageVisible: boolean
  scanImageExamineeIds: number[]
  previewScanImageExamineeId: number
  school_settings: SchoolSetting[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "preview-image-sidebar": PreviewImageSidebar,
  },
  setup(props, context){

    const modalRef = ref<InstanceType<typeof BModal>>();
    const carouselRef = ref<InstanceType<typeof BCarousel>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      sheet_id: "",
      student_no: "",
      sheet: new Sheet({}),
      examinee: new Examinee({}),
      total_result: null,
      part1_results: [],
      field_results: [],
      SheetTypeEnum: Common.SheetTypeEnum,
      sort_part1_asc: true,
      sort_total_average_asc: true,
      sort_correct_state_asc: true,
      sort_field_asc: true,
      windowHeight: 0,
      pdf_url: null,
      errors: [],
      isStudentSite: window.location.href.indexOf("student_site") != -1,
      isScanImageVisible: false,
      scanImageExamineeIds: [],
      previewScanImageExamineeId: null,
      school_settings: []
    });

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_id = context.root.$route.params.sheet_id;
      state.student_no = context.root.$route.params.student_no;
      await http.get(`/api/teacher/result_rank_detail?sheet_id=${state.sheet_id}&student_no=${state.student_no}`).then(response => {
        state.sheet = new Sheet(response.data.sheet);
        state.examinee = new Examinee(response.data.examinee);
        state.total_result = new TotalResult(response.data.total_result);
        state.part1_results = response.data.part1_results.map((x: any) => new Part1Result(x));
        state.field_results = response.data.field_results.map((x: any) => new FieldResult(x));
        state.pdf_url = response.data.pdf_url;
        state.scanImageExamineeIds = [state.examinee.id];
        state.school_settings = response.data.school_settings;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。前の画面に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。前の画面に戻ります。`);
        }
        window.history.back();
      });
      adjustHeight();
      window.addEventListener("resize", adjustHeight);
      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
    });

    /************************************************************
     * ヘッダの実施日用文言生成
     ************************************************************/

    const convertExecDateText = (execDate: string) => {
      return execDate ? moment(execDate).format('Y年M月D日実施') : "";
    };

    const rank_mongon = (rank: string) => {
      return rank ? rank + "位" : "-";
    };

    const total_mongon = (total: string) => {
      return total ? total + "位" : "-";
    };

    const decorate_is_correct = (correct_state: number) => {
      switch (correct_state) {
        case -1:
          return "×"
          break;
        case 1:
          return "○"
          break;
        case 0:
          return "△"
          break;
      }
    };

    // 大問1を並び替え
    const sort_by_part1 = () => {
      if (state.sort_part1_asc) {
        // 昇順
        state.part1_results.sort(function(a, b) {
          if (a.sort_no <= b.sort_no) {
            return 1;
          } else {
            return -1;
          }
        });
      } else {
        // 降順
        state.part1_results.sort(function(a, b) {
          if (a.sort_no >= b.sort_no) {
            return 1;
          } else {
            return -1;
          }
        });
      }
      state.sort_part1_asc = !state.sort_part1_asc
    };

    // 設問を並び替え
    const sort_by_field = () => {
      if (state.sort_field_asc) {
        // 昇順
        state.field_results.sort(function(a, b) {
          if (a.sort_no <= b.sort_no) {
            return 1;
          } else {
            return -1;
          }
        });
      } else {
        // 降順
        state.field_results.sort(function(a, b) {
          if (a.sort_no >= b.sort_no) {
            return 1;
          } else {
            return -1;
          }
        });
      }
      state.sort_field_asc = !state.sort_field_asc
    };

    // 全体正答率を並び替え
    const sort_by_total_average = () => {
      if (state.sort_total_average_asc) {
        // 昇順
        state.field_results.sort(function(a, b) {
          if (Number(a.score_rate) >= Number(b.score_rate)) {
            return 1;
          } else {
            return -1;
          }
        });
      } else {
        // 降順
        state.field_results.sort(function(a, b) {
          if (Number(a.score_rate) <= Number(b.score_rate)) {
            return 1;
          } else {
            return -1;
          }
        });
      }
      state.sort_total_average_asc = !state.sort_total_average_asc
    };

    // 正誤を並び替え
    const sort_by_correct_state = () => {
      if (state.sort_correct_state_asc) {
        // 昇順
        state.field_results.sort(function(a, b) {
          if (a.correct_state >= b.correct_state) {
            return 1;
          } else {
            return -1;
          }
        });
      } else {
        // 降順
        state.field_results.sort(function(a, b) {
          if (a.correct_state <= b.correct_state) {
            return 1;
          } else {
            return -1;
          }
        });
      }
      state.sort_correct_state_asc = !state.sort_correct_state_asc
    };

    /************************************************************
     * 答案画像モーダル表示
     ************************************************************/
    const previewImage = async () => {

      state.previewScanImageExamineeId = state.examinee.id;
      state.isScanImageVisible = true;
    };

    /************************************************************
     * 採点結果PDF表示
     ************************************************************/

    const downloadResultPdf = async () => {

      if(context.root.$store.state.isMobile){
        const button = document.getElementById("link-question");
        if(button){
          button.click();
        }
      }else{
        context.root.$store.dispatch("showOverlay");
      
        await http.get(`/api/teacher/result_rank_detail/download_result_pdf/${state.sheet_id}/${state.examinee.student_no}`, {responseType: 'arraybuffer'}).then(response => {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const a = document.createElement('a');
          a.href = window.URL.createObjectURL(blob);
          a.target = "_blank"
          a.click();
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });

        context.root.$store.dispatch("hideOverlay");
      }
    }

    /************************************************************
     * 一覧の高さを画面サイズに合わせる
     * 初期表示・ウィンドウリサイズ時に発動
     ************************************************************/

    const adjustHeight = () => {
      const windowHeight = window.innerHeight;
      state.windowHeight = windowHeight;
    };

    const isDispRank = computed((): boolean => {
      const school_setting = state.school_settings.find(x => x.key == "is_disp_rank");
      debugger
      if(school_setting && school_setting.value == "0"){
        return false;
      }else{
        return true;
      }
    });

    const isDispPart1ScoreRate = computed((): boolean => {
      const school_setting = state.school_settings.find(x => x.key == "is_disp_part1_score_rate");
      if(school_setting && school_setting.value == "0"){
        return false;
      }else{
        return true;
      }
    });

    return {
      ...toRefs(state),
      modalRef,
      carouselRef,
      convertExecDateText,
      rank_mongon,
      total_mongon,
      decorate_is_correct,
      sort_by_part1,
      sort_by_total_average,
      sort_by_correct_state,
      sort_by_field,
      previewImage,
      downloadResultPdf,
      adjustHeight,
      isDispRank,
      isDispPart1ScoreRate,
    };
  }
});

